import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ModalBody, ModalHeader } from 'reactstrap';
import { VrrButton, VrrModal } from '../../shared_components';
import { getSteps } from './services';
import { TImportDataModal } from './types';
import './ImportDataModal.scss';

const ImportDataModal: React.FC<TImportDataModal> = ({
  isOpen,
  onCancelAction
}) => {
  const { t } = useTranslation();
  const [currentStep, setCurrentStep] = useState(0);

  useEffect(() => {
    return () => {
      setCurrentStep(0);
    };
  }, []);

  return (
    <VrrModal
      withClose
      className="import-data-modal"
      isOpen={isOpen}
      modalHeader={
        <ModalHeader
          className="creative-modal-header"
          close={
            <VrrButton
              className="import-data-cancel-button"
              onClick={onCancelAction}
              icon={{
                iconLabel: 'tim-icons icon-simple-remove'
              }}
            />
          }
        >
          <span>
            <i className="tim-icons icon-zoom-split circle-icon" />
          </span>
          <span className="creative-modal-title">
            {t(
              `import_data.import_data_modal.${currentStep}.title`
            ).toUpperCase()}
          </span>
        </ModalHeader>
      }
      modalBody={
        <ModalBody className="import-data-modal-body">
          <p>{t(`import_data.import_data_modal.${currentStep}.description`)}</p>
          {getSteps(currentStep)}
        </ModalBody>
      }
      toggleModal={onCancelAction}
      {...(currentStep > 1 && {
        toggleValidation: () => {},
        enabledValidationButton: true,
        validationText:
          currentStep === 3
            ? t(`import_data.import_data_modal.import`)
            : t(`import_data.import_data_modal.next`),
        otherAction: true,
        otherToggleValidation: () => {},
        otherActionText: t(`import_data.import_data_modal.back`)
      })}
      scrollable
    />
  );
};
export default ImportDataModal;
